import Page from '@/ui/components/page';
import exodus from '@/ui/exodus.js';
import useExpandedEffect from '@/ui/hooks/use-expanded-effect.js';
import { cn } from '@/ui/utils/classnames';
import { useNavigate } from '@/ui/utils/navigation';
import CollectibleItem from './components/collectible-item.js';
import EmptyState from './components/empty-state/index.js';
import Loading from './components/loading.js';
import useCollectibles from './hooks/use-collectibles.js';

function CollectiblesPage() {
  const navigate = useNavigate();

  const { nfts, sbt, loading } = useCollectibles();

  useExpandedEffect(() => {
    exodus.analytics.track({
      event: 'NFTGalleryView',
    });
  }, []);

  return (
    <Page>
      {loading ? (
        <Loading />
      ) : !sbt && !nfts?.length ? (
        <EmptyState />
      ) : (
        <div
          className={cn(
            'grid grid-cols-2 gap-4',
            'pb-[104px]', // 104px padding to accommodate for the floating navbar.
            __STANDALONE_MODE__ && 'sm:pb-8', // The floating navbar is outside the page layout in standalone mode.
          )}
        >
          {sbt && (
            <CollectibleItem
              data={sbt}
              onClick={() => navigate(`/collectibles/${sbt.id}`)}
            />
          )}
          {nfts.map((nft) => (
            <CollectibleItem
              key={nft.id}
              data={nft}
              onClick={() =>
                navigate(`/collectibles/${encodeURIComponent(nft.id)}`)
              }
            />
          ))}
        </div>
      )}
    </Page>
  );
}

export default CollectiblesPage;
